import { OverlayLoader } from 'components/Loaders'
import { actions, selectors } from 'data'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import GeneralAlert from './GeneralAlert'

type Props = {
  children: React.ReactNode
}

const AppConfig = ({ children }: Props) => {
  const dispatch = useDispatch()
  useEffect(function BootstrapHook() {
    dispatch(actions.config.fetch())
  }, [])

  const errorLoadingConfig = useSelector(selectors.config.hasError)
  const hasConfig = useSelector(selectors.config.hasConfig)

  if (hasConfig) return <>{children}</>

  if (errorLoadingConfig) return <GeneralAlert code='CONF-001' />

  return <OverlayLoader />
}

export default AppConfig
